export default "__VITE_ASSET__CNMgTU7Q__"